import { render } from 'preact';
import { App } from './app';
import './styles/app.css';

/**
 * The service worker is registered manually rather than auto-updating, so a
 * new build never swaps itself in mid-entry and loses what was being typed.
 */
import { registerSW } from 'virtual:pwa-register';

const updateSW = registerSW({
  onNeedRefresh() {
    // Deliberately quiet: the update applies on the next cold launch.
    // Anything louder interrupts a log for no benefit.
    void updateSW;
  },
});

const root = document.getElementById('app');
if (root) render(<App />, root);
